import { IconLookup } from "@fortawesome/fontawesome-svg-core";
import { faFile } from "@fortawesome/free-regular-svg-icons";
import { faFileCirclePlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useToastContext } from "components/alert/ToastContext";
import ModalDocumentoAcesso from "components/modal/documentos/acesso/ModalDocumentoAcesso";
import ModalDocumentoPastaAcesso from "components/modal/documentos/acesso/ModalDocumentoPastaAcesso";
import ModalDocumentoAdicionarRevisao from "components/modal/documentos/ModalDocumentoAdicionarRevisao";
import ModalDocumentoVisualizar from "components/modal/documentos/ModalDocumentoVisualizar";
import ModalDocumentoMover from "components/modal/documentos/pasta/ModalDocumentoMover";
import ModalDocumentoPastaCriar from "components/modal/documentos/pasta/ModalDocumentoPastaCriar";
import ModalDocumentoPastaEditar from "components/modal/documentos/pasta/ModalDocumentoPastaEditar";
import ModalFiltrosListaMestra from "components/modal/documentos/pasta/ModalFiltrosListaMestra";
import ModalPastaMover from "components/modal/documentos/pasta/ModalPastaMover";
import ModalDocumentoSolicitarRevisao from "components/modal/documentos/solicitacao/ModalDocumentoSolicitarRevisao";
import ModalVerRelatorio from "components/modal/ModalVerRelatorio";
import ReportEdit from "components/reports/ReportEdit";
import saveAs from 'file-saver';
import Documento from "model/documentos/Documento";
import { DocumentoPasta } from "model/documentos/DocumentoPasta";
import DocumentoVersao from "model/documentos/DocumentoVersao";
import FiltrosListaMestra from "model/documentos/FiltrosListaMestra";
import { Button } from "primereact/button";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Dialog } from "primereact/dialog";
import { Menu } from "primereact/menu";
import { SplitButton } from "primereact/splitbutton";
import { useLoadingContext } from "provider/LoadingProvider";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router";
import DocumentoPastaService from "service/documentos/DocumentoPastaService";
import DocumentoService from "service/documentos/DocumentoService";
import UsuarioLogadoService from "service/usuario/UsuarioLogadoService";
import { converterData, diasParaVencer } from "utils/convert";
import DocumentoCadastro from "./DocumentoCadastro";
import "./style/DocumentoPastaPage.css";
import ModalDocumentoVersaoAlterarValidade from "components/modal/documentos/ModalDocumentoVersaoAlterarValidade";
import { errorDecoder } from "utils/errorUtil";

const documentoPastaService = new DocumentoPastaService();
const documentoService = new DocumentoService();
const usuarioLogadoService = new UsuarioLogadoService();

export default function DocumentoPastaPage() {
    const [pasta, setPasta] = useState<DocumentoPasta | null>(null);

    const [visiblePastaCriar, setVisiblePastaCriar] = useState(false);
    const [visibleDocumentoCadastro, setVisibleDocumentoCadastro] = useState(false);
    const [pastaAlterar, setPastaAlterar] = useState<{ visible: boolean, pasta: DocumentoPasta | null }>({ visible: false, pasta: null });
    const [pastaMover, setPastaMover] = useState<{ visible: boolean, pasta: DocumentoPasta | null }>({ visible: false, pasta: null });
    const [documentoAlterarPasta, setDocumentoAlterarPasta] = useState<{ visible: boolean, documento: Documento | null }>({ visible: false, documento: null });
    const [documentoAdicionarRevisao, setDocumentoAdicionarRevisao] = useState<{ visible: boolean, documento: Documento | null }>({ visible: false, documento: null });
    const [documentoSolicitarRevisao, setDocumentoSolicitarRevisao] = useState<{ visible: boolean, documento: Documento | null }>({ visible: false, documento: null });

    const [permiteAdicionarDocumento, setPermiteAdicionarDocumento] = useState(false);
    const [editaRelatorioListaMestra, setEditaRelatorioListaMestra] = useState(false);
    const [imprimeListaMestra, setImprimeListaMestra] = useState(false);
    const [editaRelatorioDocumentosDistribuidos, setEditaRelatorioDocumentosDistribuidos] = useState(false);
    const [imprimeDocumentosDistribuidos, setImprimeDocumentosDistribuidos] = useState(false);
    const [visibleDialogRelatorios, setVisibleDialogRelatorios] = useState(false);
    const [modalFiltroListaMestra, setModalFiltroListaMestra] = useState({ visible: false, tipo: "" });
    const [modalVerRelatorio, setModalVerRelatorio] = useState<{ visible: boolean, nomeRelatorio: string, url: string }>({ visible: false, nomeRelatorio: "", url: "" });

    const [consultaPermissao, setConsultaPermissao] = useState(false);

    const [documentoVisualizar, setDocumentoVisualizar] = useState<{ visible: boolean, documentoVersao: DocumentoVersao | null, url: string }>({ visible: false, documentoVersao: null, url: "" });
    const [documentoAcessoModal, setDocumentoAcessoModal] = useState<{ visible: boolean, idDocumento: number }>({ visible: false, idDocumento: 0 });
    const [documentoVersaoAlterarValidade, setDocumentoVersaoAlterarValidade] = useState<{ visible: boolean, documentoVersao: DocumentoVersao | null }>({ visible: false, documentoVersao: null });
    const [documentoPastaAcessoModal, setDocumentoPastaAcessoModal] = useState<{ visible: boolean, idPasta: number }>({ visible: false, idPasta: 0 });

    const menuPastaRef = useRef<Menu[]>([]);
    const menuDocumentoRef = useRef<Menu[]>([]);
    const navigate = useNavigate();
    const { msgAlerta, msgErro } = useToastContext();
    const { startLoading, stopLoading } = useLoadingContext();

    useEffect(() => {
        buscarRoot();
    }, []);

    useEffect(() => {
        usuarioLogadoService.getAcoesUsuarioLogado().then((resposta) => {
            if (usuarioLogadoService.usuarioTemAlgumaAcao(resposta, ["RELATORIO_DOCUMENTO_LISTA_MESTRA_EDITAR"])) {
                setEditaRelatorioListaMestra(true);
            }
            if (usuarioLogadoService.usuarioTemAlgumaAcao(resposta, ["RELATORIO_DOCUMENTO_DISTRIBUICAO_EDITAR"])) {
                setEditaRelatorioDocumentosDistribuidos(true);
            }
            if (usuarioLogadoService.usuarioTemAlgumaAcao(resposta, ["RELATORIO_DOCUMENTO_LISTA_MESTRA_IMPRIMIR"])) {
                setImprimeListaMestra(true);
            }
            if (usuarioLogadoService.usuarioTemAlgumaAcao(resposta, ["RELATORIO_DOCUMENTO_DISTRIBUICAO_IMPRIMIR"])) {
                setImprimeDocumentosDistribuidos(true);
            }
            if (usuarioLogadoService.usuarioTemAlgumaAcao(resposta, ["DOCUMENTO_PERMISSAO_ALTERAR", "DOCUMENTO_PERMISSAO_CONSULTAR"])) {
                setConsultaPermissao(true);
            }
            if (usuarioLogadoService.usuarioTemAlgumaAcao(resposta, ["DOCUMENTO_PERMISSAO_ALTERAR", "DOCUMENTO_PERMISSAO_CONSULTAR"])) {
                setPermiteAdicionarDocumento(true);
            }
        }).catch((erro) => {
            console.log(erro);
        });
    }, []);

    function buscarRoot() {
        startLoading();
        documentoPastaService.consultarRoot().then((response) => {
            setPasta(response);
            stopLoading();
        }).catch((error) => {
            console.error("Erro ao buscar pasta raiz:", error);
            stopLoading();
        });
    }

    function buscarPasta(id: number) {
        startLoading();
        documentoPastaService.consultar(id).then((response) => {
            setPasta(response);
            stopLoading();
        }).catch((error) => {
            stopLoading();
            console.error("Erro ao buscar pasta:", error);
        });
    }

    function navegarParaPasta(pasta: DocumentoPasta) {
        if (pasta.acoesUsuarioLogado && pasta.acoesUsuarioLogado.findIndex((e) => e.sigla == "VISUALIZAR") < 0) {
            msgAlerta("Atenção", "Você não tem permissão para visualizar esta pasta.");
            return
        }
        buscarPasta(pasta.id)
    }

    function gerarRelatorioListaMestra(filtros: FiltrosListaMestra) {
        startLoading();
        documentoPastaService.getRelatorioListaMestra(filtros).then(data => {
            stopLoading();
            const file = new Blob([data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(file);
            setModalVerRelatorio({ visible: true, nomeRelatorio: "Lista Mestra", url: url });
        }).catch(err => {
            stopLoading();
            msgErro("Erro ao gerar Relatório", err?.message || "");
            console.log(err);
        });
    }

    function gerarRelatorioDocumentosDistribuidos(filtros: FiltrosListaMestra) {
        startLoading();
        documentoPastaService.getRelatorioDocumentosDistribuidos(filtros).then(data => {
            stopLoading();
            const file = new Blob([data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(file);
            setModalVerRelatorio({ visible: true, nomeRelatorio: "Lista Mestra - Documentos distribuídos", url: url });
        }).catch(err => {
            stopLoading();
            msgErro("Erro ao gerar Relatório", err?.message || "");
            console.log(err);
        });
    }

    function baixarPasta(id?: number, index?: number) {
        startLoading();
        documentoPastaService.downloadZip(id).then((data) => {
            stopLoading();
            const file = new Blob([data], { type: 'application/zip' });
            saveAs(file, index ? pasta?.pastas[index].nome + ".zip" : pasta?.nome + ".zip");
        }).catch((error) => {
            stopLoading();
            msgErro("Erro ao baixar pasta", error?.data?.message || "Erro ao baixar pasta");
            console.error("Erro ao baixar pasta:", error);
        });
    }

    const renderPastaOptions = (index: number) => {

        return [
            {
                label: 'Opções',
                items: [
                    {
                        visible: pasta?.pastas[index] && pasta?.pastas[index].acoesUsuarioLogado.findIndex((e) => e.sigla == "BAIXAR") > -1,
                        label: 'Baixar',
                        icon: <FontAwesomeIcon icon={"download"} style={{ marginRight: 8 }} />,
                        command: () => {
                            baixarPasta(pasta?.pastas[index].id, index);
                        }
                    },
                    {
                        visible: pasta?.pastas[index] && pasta?.pastas[index].acoesUsuarioLogado.findIndex((e) => e.sigla == "MOVER") > -1,
                        label: 'Mover',
                        icon: 'pi pi-arrow-right-arrow-left',
                        command: () => {
                            setPastaMover({ visible: true, pasta: pasta?.pastas[index] || null });
                        }
                    },
                    {
                        visible: pasta?.pastas[index] && pasta?.pastas[index].acoesUsuarioLogado.findIndex((e) => e.sigla == "EDITAR") > -1,
                        label: 'Editar',
                        icon: 'pi pi-pencil',
                        command: () => {
                            setPastaAlterar({ visible: true, pasta: pasta?.pastas[index] || null });
                        }
                    },
                    {
                        visible: pasta?.pastas[index] && pasta?.pastas[index].acoesUsuarioLogado.findIndex((e) => e.sigla == "ENVIAR_PARA_LIXEIRA") > -1,
                        label: 'Enviar para lixeira',
                        icon: 'pi pi-trash',
                        command: () => {
                            confirmDialog({
                                message: 'Tem certeza que deseja enviar esta pasta para lixeira?',
                                header: 'Confirmação',
                                icon: 'pi pi-exclamation-triangle',
                                acceptLabel: "Sim",
                                rejectLabel: "Não",
                                accept: () => {
                                    startLoading();
                                    documentoPastaService.remover(pasta?.pastas[index].id || 0).then(() => {
                                        stopLoading();
                                        if (pasta?.id) {
                                            buscarPasta(pasta.id);
                                        } else {
                                            buscarRoot();
                                        }
                                    }).catch((error) => {
                                        stopLoading();
                                        msgErro("Erro ao remover pasta", error?.data?.message || "Erro ao remover pasta");
                                        console.error("Erro ao remover pasta:", error);
                                    });
                                }
                            });
                        }
                    },
                    {
                        visible: pasta?.pastas[index] && pasta?.pastas[index].acoesUsuarioLogado.findIndex((e) => e.sigla == "EXCLUIR_PERMANENTEMENTE") > -1,
                        label: 'Excluir permanentemente',
                        icon: 'pi pi-trash',
                        command: () => {
                            confirmDialog({
                                message: 'Tem certeza que deseja excluir esta pasta permanentemente?',
                                header: 'Confirmação',
                                icon: 'pi pi-exclamation-triangle',
                                acceptLabel: "Sim",
                                rejectLabel: "Não",
                                accept: () => {
                                    startLoading();
                                    documentoPastaService.excluirPermanentemente(pasta?.pastas[index].id || 0).then(() => {
                                        stopLoading();
                                        if (pasta?.id) {
                                            buscarPasta(pasta.id);
                                        } else {
                                            buscarRoot();
                                        }
                                    }).catch((error) => {
                                        stopLoading();
                                        msgErro("Erro ao excluir pasta", error?.data?.message || "Erro ao excluir pasta");
                                        console.error("Erro ao excluir pasta permanentemente:", error);
                                    });
                                }
                            });
                        }
                    },
                    {
                        visible: consultaPermissao,
                        label: 'Permissões',
                        icon: <FontAwesomeIcon icon={"key"} style={{ marginRight: 8 }} />,
                        command: () => {
                            console.log(pasta?.pastas[index]);
                            setDocumentoPastaAcessoModal({ visible: true, idPasta: pasta?.pastas[index].id || 0 });
                        }
                    }
                ]
            }
        ];
    }

    function visualizarDocumento(documento: Documento) {
        if (documento.acoesUsuarioLogado.findIndex((e) => e.sigla == "VISUALIZAR") == -1) {
            msgAlerta("Atenção", "Você não tem permissão para visualizar este documento.");
            return;
        }
        startLoading();
        documentoPastaService.versaoPublicada(documento.id || 0).then((versao) => {
            stopLoading();
            setDocumentoVisualizar({ visible: true, documentoVersao: versao, url: versao?.arquivo?.url || "" });
        }).catch((error) => {
            stopLoading();
            msgErro("Erro ao baixar documento", error?.data?.message || "Erro ao baixar documento");
            console.error("Erro ao baixar documento:", error);
        });
    }

    function imprimirDocumento(documento: Documento) {
        if (documento.acoesUsuarioLogado.findIndex((e) => e.sigla == "IMPRIMIR") == -1) {
            msgAlerta("Atenção", "Você não tem permissão para imprimir este documento.");
            return;
        }
        startLoading();

        documentoPastaService.getCopiaNaoControlada(documento.id || 0)
            .then(blob => {
                const fileURL = URL.createObjectURL(blob);
                const printWindow = window.open(fileURL, '_blank');
                if (printWindow) {
                    printWindow.addEventListener('load', () => {
                        printWindow.print();
                    });
                } else {
                    msgErro("Erro ao abrir janela de impressão", "Não foi possível abrir a janela de impressão. Verifique se o bloqueador de pop-ups está ativado.");
                }
            })
            .catch(async (e) => {
                let erro = await errorDecoder(e);
                msgErro("Erro", erro || "Erro ao imprimir documento");
                console.error(e)
            }).finally(() => {
                stopLoading();
            });
        return false;
    }


    const renderDocumentoOptions = (index: number) => {

        return [
            {
                label: 'Opções',
                items: [
                    {
                        visible: pasta?.documentos[index] && pasta?.documentos[index].acoesUsuarioLogado.findIndex((e) => e.sigla == "VISUALIZAR") > -1,
                        label: 'Visualizar',
                        icon: 'pi pi-eye',
                        command: () => {
                            visualizarDocumento((pasta?.documentos[index] || null) as Documento);
                        }
                    },
                    {
                        visible: pasta?.documentos[index] && pasta?.documentos[index].acoesUsuarioLogado.findIndex((e) => e.sigla == "IMPRIMIR") > -1,
                        label: 'Imprimir',
                        icon: 'pi pi-print',
                        command: () => {
                            imprimirDocumento((pasta?.documentos[index] || null) as Documento);
                        }
                    },
                    {
                        visible: pasta?.documentos[index] && pasta?.documentos[index].acoesUsuarioLogado.findIndex((e) => e.sigla == "BAIXAR") > -1,
                        label: 'Baixar',
                        icon: <FontAwesomeIcon icon={"download"} style={{ marginRight: 8 }} />,
                        command: () => {
                            startLoading();
                            documentoPastaService.versaoPublicada(pasta?.documentos[index].id || 0).then((versao) => {
                                stopLoading();
                                fetch(versao?.arquivo?.url || "")
                                    .then(res => res.blob())
                                    .then(blob => saveAs(blob, versao?.arquivo?.nome || "arquivo"))
                                    .catch(e => {
                                        console.error(e)
                                    });
                                return false;
                            }).catch((error) => {
                                stopLoading();
                                msgErro("Erro ao baixar documento", error?.data?.message || "Erro ao baixar documento");
                                console.error("Erro ao baixar documento:", error);
                            });
                        }
                    },
                    {
                        visible: pasta?.documentos[index] && pasta?.documentos[index].acoesUsuarioLogado.findIndex((e) => e.sigla == "PROPRIEDADES") > -1,
                        label: 'Propriedades',
                        icon: <FontAwesomeIcon icon={"wrench"} style={{ marginRight: 8 }} />,
                        command: () => {
                            navigate("/documento/editar/" + pasta?.documentos[index].id);
                        }
                    },
                    {
                        visible: pasta?.documentos[index] && pasta?.documentos[index].acoesUsuarioLogado.findIndex((e) => e.sigla == "MOVER") > -1,
                        label: 'Mover',
                        icon: 'pi pi-arrow-right-arrow-left',
                        command: () => {
                            setDocumentoAlterarPasta({ visible: true, documento: pasta?.documentos[index] || null });
                        }
                    },
                    {
                        visible: pasta?.documentos[index] && pasta?.documentos[index].tipoGestao !== "GED" && pasta?.documentos[index].acoesUsuarioLogado.findIndex((e) => e.sigla == "ADICIONAR_REVISAO") > -1,
                        label: 'Revisar',
                        icon: 'pi pi-plus',
                        command: () => {
                            setDocumentoAdicionarRevisao({ visible: true, documento: pasta?.documentos[index] || null });
                        }
                    },
                    {
                        visible: pasta?.documentos[index] && pasta?.documentos[index].tipoGestao !== "GED" && pasta?.documentos[index].acoesUsuarioLogado.findIndex((e) => e.sigla == "SOLICITAR_REVISAO") > -1,
                        label: 'Solicitar revisão',
                        icon: 'pi pi-plus',
                        command: () => {
                            setDocumentoSolicitarRevisao({ visible: true, documento: pasta?.documentos[index] || null });
                        }
                    },
                    {
                        visible: pasta?.documentos[index] && pasta?.documentos[index].acoesUsuarioLogado.findIndex((e) => e.sigla == "ENVIAR_PARA_LIXEIRA") > -1,
                        label: 'Enviar para lixeira',
                        icon: 'pi pi-trash',
                        command: () => {
                            confirmDialog({
                                message: 'Tem certeza que deseja enviar este documento para lixeira?',
                                header: 'Confirmação',
                                icon: 'pi pi-exclamation-triangle',
                                acceptLabel: "Sim",
                                rejectLabel: "Não",
                                accept: () => {
                                    startLoading();
                                    const pastaMae = pasta?.documentos[index]?.pastaMae;
                                    documentoPastaService.removerDocumento(pasta?.documentos[index].id || 0).then(() => {
                                        stopLoading();
                                        if (pastaMae) {
                                            buscarPasta(pastaMae.id);
                                        } else {
                                            buscarRoot();
                                        }
                                    }).catch((error) => {
                                        stopLoading();
                                        msgErro("Erro ao remover documento", error?.data?.message || "Erro ao remover documento");
                                        console.error("Erro ao remover documento:", error);
                                    });
                                }
                            });
                        }
                    },
                    {
                        visible: pasta?.documentos[index] && pasta?.documentos[index].acoesUsuarioLogado.findIndex((e) => e.sigla == "EXCLUIR_PERMANENTEMENTE") > -1,
                        label: 'Excluir permanentemente',
                        icon: 'pi pi-trash',
                        command: () => {
                            confirmDialog({
                                message: 'Tem certeza que deseja excluir este documento permanentemente?',
                                header: 'Confirmação',
                                icon: 'pi pi-exclamation-triangle',
                                acceptLabel: "Sim",
                                rejectLabel: "Não",
                                accept: () => {
                                    startLoading();
                                    const pastaMae = pasta?.documentos[index]?.pastaMae;
                                    documentoPastaService.excluirDocumentoPermanentemente(pasta?.documentos[index].id || 0).then(() => {
                                        stopLoading();
                                        if (pastaMae) {
                                            buscarPasta(pastaMae.id);
                                        } else {
                                            buscarRoot();
                                        }
                                    }).catch((error) => {
                                        stopLoading();
                                        msgErro("Erro ao excluir documento", error?.data?.message || "Erro ao excluir documento");
                                        console.error("Erro ao excluir documento permanentemente:", error);
                                    });
                                }
                            });
                        }
                    },
                    {
                        visible: pasta?.documentos[index] && pasta?.documentos[index].acoesUsuarioLogado.findIndex((e) => e.sigla == "ALTERAR_VALIDADE") > -1,
                        label: 'Alterar validade',
                        icon: <FontAwesomeIcon icon={"calendar"} style={{ marginRight: 8 }} />,
                        command: () => {
                            if (!pasta?.documentos[index].versaoVigente) {
                                msgAlerta("Atenção", "Este documento não possui uma versão vigente.");
                                return;
                            }
                            setDocumentoVersaoAlterarValidade({ visible: true, documentoVersao: pasta?.documentos[index].versaoVigente || null });
                        }
                    },
                    {
                        visible: consultaPermissao,
                        label: 'Permissões',
                        icon: <FontAwesomeIcon icon={"key"} style={{ marginRight: 8 }} />,
                        command: () => {
                            setDocumentoAcessoModal({ visible: true, idDocumento: pasta?.documentos[index].id || 0 });
                        }
                    }
                ]
            }
        ];
    }

    const renderRelatorioButton = () => {
        if (!imprimeListaMestra && !imprimeDocumentosDistribuidos) {
            return <Button label="Alterar Relatórios"
                className="p-button-rounded"
                onClick={() => setVisibleDialogRelatorios(true)}
            />;
        }
        return (
            <SplitButton
                icon="pi pi-file-pdf"
                className="p-button-rounded"
                label={imprimeListaMestra ? "Lista Mestra" : "Documentos Distribuídos"}
                style={{ marginRight: 8 }}
                onClick={() => setModalFiltroListaMestra({ visible: true, tipo: imprimeListaMestra ? "listaMestra" : "documentosDistribuidos" })}
                model={[
                    {
                        label: "Documentos distribuídos",
                        icon: "pi pi-file-pdf",
                        command: () => setModalFiltroListaMestra({ visible: true, tipo: "documentosDistribuidos" }),
                        visible: imprimeDocumentosDistribuidos && imprimeListaMestra,
                    },
                    {
                        label: "Alterar relatórios",
                        visible: editaRelatorioListaMestra || editaRelatorioDocumentosDistribuidos,
                        command: () => setVisibleDialogRelatorios(true)
                    }
                ]}
            />
        )
    }

    function getValidadeColor(documento: Documento) {
        if (documento.alertaVencimento) {
            const dataAlerta = new Date();
            dataAlerta.setHours(23, 59, 59, 999);

            if (documento.versaoVigente?.validade) {
                const validade = new Date(documento.versaoVigente?.validade);
                dataAlerta.setDate(dataAlerta.getDate() + documento.diasAlertaVencimento);
                if (dataAlerta.getTime() >= validade.getTime()) {
                    return "#cc8f00"
                }
            }
        }
        return "#000"
    }

    return (
        <div>
            <Dialog visible={visibleDialogRelatorios}
                onHide={() => setVisibleDialogRelatorios(false)}
                header="Relatórios"
                style={{ width: "50%" }}
            >
                {editaRelatorioListaMestra ? <ReportEdit nomeAcao="RELATORIO_DOCUMENTO_LISTA_MESTRA_EDITAR" titulo="Relatório Lista Mestra" testarRelatorio={() => { }} style={{ marginBottom: 10 }} /> : null}
                {editaRelatorioDocumentosDistribuidos ? <ReportEdit nomeAcao="RELATORIO_DOCUMENTO_DISTRIBUICAO_EDITAR" titulo="Relatório Documentos Distribuídos" testarRelatorio={() => { }} style={{ marginBottom: 10 }} /> : null}
            </Dialog>
            {visibleDocumentoCadastro ? <Dialog header="Cadastro de Documento" visible={visibleDocumentoCadastro} onHide={() => setVisibleDocumentoCadastro(false)} style={{ width: '75vw' }} >
                <DocumentoCadastro isModal onSave={() => {
                    setVisibleDocumentoCadastro(false);
                    !pasta || pasta.id <= 0 ? buscarRoot() : buscarPasta(pasta.id)
                }} />
            </Dialog> : null}
            {documentoAdicionarRevisao.visible ? <ModalDocumentoAdicionarRevisao
                visible={documentoAdicionarRevisao.visible}
                onHide={() => setDocumentoAdicionarRevisao({ visible: false, documento: null })}
                documento={documentoAdicionarRevisao.documento as Documento}
                onConfirm={() => !pasta || pasta.id <= 0 ? buscarRoot() : buscarPasta(pasta.id)}
            /> : null}
            {documentoSolicitarRevisao.visible ? <ModalDocumentoSolicitarRevisao
                visible={documentoSolicitarRevisao.visible}
                onHide={() => setDocumentoSolicitarRevisao({ visible: false, documento: null })}
                documento={documentoSolicitarRevisao.documento as Documento}
                onConfirm={() => !pasta || pasta.id <= 0 ? buscarRoot() : buscarPasta(pasta.id)}
            /> : null}
            {modalFiltroListaMestra.visible ? <ModalFiltrosListaMestra
                visible={modalFiltroListaMestra.visible}
                onHide={() => setModalFiltroListaMestra({ visible: false, tipo: "" })}
                onConfirm={(filtros) => {
                    if (modalFiltroListaMestra.tipo == "listaMestra") {
                        gerarRelatorioListaMestra(filtros);
                    } else if (modalFiltroListaMestra.tipo == "documentosDistribuidos") {
                        gerarRelatorioDocumentosDistribuidos(filtros);
                    }
                }}
            /> : null}
            <ConfirmDialog />
            {pastaAlterar.visible ? <ModalDocumentoPastaEditar
                visible={pastaAlterar.visible}
                onHide={() => setPastaAlterar({ visible: false, pasta: null })}
                pasta={pastaAlterar.pasta as DocumentoPasta}
                onConfirm={() => !pasta || pasta.id == 0 ? buscarRoot() : buscarPasta(pasta.id)}
            /> : null}
            {pastaMover.visible ? <ModalPastaMover
                visible={pastaMover.visible}
                onHide={() => setPastaMover({ visible: false, pasta: null })}
                pasta={pastaMover.pasta as DocumentoPasta}
                onConfirm={() => !pasta || pasta.id == 0 ? buscarRoot() : buscarPasta(pasta.id)}
            /> : null}
            {visiblePastaCriar ? <ModalDocumentoPastaCriar
                visible={visiblePastaCriar}
                onHide={() => setVisiblePastaCriar(false)}
                pastaMae={pasta}
                onConfirm={() => !pasta || pasta.id == 0 ? buscarRoot() : buscarPasta(pasta.id)}
            /> : null}
            {documentoAlterarPasta.visible ? <ModalDocumentoMover
                visible={documentoAlterarPasta.visible}
                onHide={() => setDocumentoAlterarPasta({ visible: false, documento: null })}
                documento={documentoAlterarPasta.documento as Documento}
                onConfirm={() => !pasta || pasta.id == 0 ? buscarRoot() : buscarPasta(pasta.id)}
            /> : null}
            {documentoVisualizar.visible ? <ModalDocumentoVisualizar
                url={documentoVisualizar.url}
                visible={documentoVisualizar.visible}
                onHide={() => setDocumentoVisualizar({ visible: false, documentoVersao: null, url: "" })}
                documentoVersao={documentoVisualizar.documentoVersao}
            /> : null}
            {documentoVersaoAlterarValidade.visible ? <ModalDocumentoVersaoAlterarValidade
                visible={documentoVersaoAlterarValidade.visible}
                onHide={() => setDocumentoVersaoAlterarValidade({ visible: false, documentoVersao: null })}
                documentoVersao={documentoVersaoAlterarValidade.documentoVersao}
                onConfirm={() => {
                    !pasta || pasta.id == 0 ? buscarRoot() : buscarPasta(pasta.id);
                    setDocumentoVersaoAlterarValidade({ visible: false, documentoVersao: null });
                }}
            /> : null}
            {documentoAcessoModal.visible ? <ModalDocumentoAcesso
                visible={documentoAcessoModal.visible}
                onHide={() => setDocumentoAcessoModal({ visible: false, idDocumento: 0 })}
                idDocumento={documentoAcessoModal.idDocumento}
                onConfirm={() => !pasta || pasta.id == 0 ? buscarRoot() : buscarPasta(pasta.id)}
            /> : null}
            {documentoPastaAcessoModal.visible ? <ModalDocumentoPastaAcesso
                visible={documentoPastaAcessoModal.visible}
                onHide={() => setDocumentoPastaAcessoModal({ visible: false, idPasta: 0 })}
                idPasta={documentoPastaAcessoModal.idPasta}
                onConfirm={() => !pasta || pasta.id == 0 ? buscarRoot() : buscarPasta(pasta.id)}
            /> : null}
            {modalVerRelatorio.visible ? <ModalVerRelatorio
                nomeRelatorio={modalVerRelatorio.nomeRelatorio}
                visible={modalVerRelatorio.visible}
                onHide={() => setModalVerRelatorio({ visible: false, nomeRelatorio: "", url: "" })}
                urlRelatorio={modalVerRelatorio.url}
            /> : null}

            <table className="table-DocumentoPasta">
                <thead>
                    <tr>
                        <th colSpan={10} style={{ padding: "10px" }}>
                            <div style={{ display: "flex", justifyContent: "space-between", flexDirection: "row", alignItems: "center", }}>
                                <div style={{ display: "flex", alignItems: "center", columnGap: "12px" }}>
                                    {pasta?.id != 0 && <Button
                                        icon="pi pi-arrow-left"
                                        onClick={() => {
                                            if (pasta?.pastaMae) {
                                                buscarPasta(pasta.pastaMae.id);
                                            } else {
                                                buscarRoot();
                                            }
                                        }}
                                    />}
                                    <span>{pasta?.nome}</span>
                                </div>


                                <div>
                                    {imprimeListaMestra || imprimeDocumentosDistribuidos || editaRelatorioDocumentosDistribuidos || editaRelatorioListaMestra ? renderRelatorioButton() : null}
                                    {pasta && pasta.acoesUsuarioLogado && pasta?.acoesUsuarioLogado.findIndex((acao) => acao.sigla == "BAIXAR") > -1 ? <Button
                                        icon="pi pi-download"
                                        label="Baixar Pasta"
                                        className="p-button-rounded"
                                        onClick={() => baixarPasta(pasta?.id)}
                                    /> : null}
                                    {permiteAdicionarDocumento ? <Button
                                        icon={<FontAwesomeIcon style={{ marginRight: 5 }} icon={faFileCirclePlus as IconLookup} />}
                                        label="Criar Documento"
                                        className="p-button-rounded"
                                        style={{ marginLeft: "10px" }}
                                        onClick={() => setVisibleDocumentoCadastro(true)}
                                    /> : null}
                                    <Button
                                        icon="pi pi-plus"
                                        label="Criar Pasta"
                                        className="p-button-rounded"
                                        style={{ marginLeft: "10px" }}
                                        onClick={() => setVisiblePastaCriar(true)}
                                    />
                                </div>

                            </div>
                        </th>
                    </tr>
                    <tr>
                        <th style={{ width: "50px" }}></th>
                        <th>Nome</th>
                        <th>Código</th>
                        <th>Categoria</th>
                        <th>Status</th>
                        <th>Última publicação</th>
                        <th>Versão</th>
                        <th>Validade</th>
                        <th>Vencimento</th>
                        <th style={{ width: "50px" }}></th>
                    </tr>
                </thead>
                <tbody>
                    {pasta?.pastas && pasta?.pastas.map((subPasta, index) => (
                        <tr key={subPasta.id} >
                            <td style={{ width: "50px" }} onClick={() => navegarParaPasta(subPasta)}>
                                <FontAwesomeIcon icon="folder" size="xl" color="#2c1492" />
                            </td>
                            <td colSpan={8} style={{ fontSize: 16 }} onClick={() => navegarParaPasta(subPasta)}>{subPasta.nome}</td>
                            <td>
                                <div className="tres-pontos" onClick={(e) => { menuPastaRef.current[index].toggle(e) }}></div>
                                <Menu model={renderPastaOptions(index)} popup ref={(ref) => menuPastaRef.current[index] = ref as Menu} id="popup_menu_left" />
                            </td>
                        </tr>
                    ))}
                    {pasta?.documentos && pasta?.documentos.map((documento, index) => (
                        <tr key={documento.id} onDoubleClick={() => visualizarDocumento(documento)}>
                            <td>
                                <FontAwesomeIcon icon={faFile as IconLookup} size="xl" color="#2c1492" />
                            </td>
                            <td>{documento.nome}</td>
                            <td>{documento.codigoInterno}</td>
                            <td>{documento.categoria?.nome}</td>
                            <td><span style={{ borderRadius: 20, padding: 5, paddingLeft: 10, paddingRight: 10, background: documentoService.getStatusColor(documento.status) }}>{documentoService.getStatus(documento.status)}</span></td>
                            <td>{converterData(documento.versaoVigente?.dataPublicacao as Date | null)}</td>
                            <td>{documento.versaoVigente?.sequencial || documento.versaoVigente?.sequencial === 0 ? documento.versaoVigente?.sequencial : ""}</td>
                            <td>{documento.versaoVigente?.validade ? converterData(documento.versaoVigente?.validade) : ""}</td>
                            <td style={{ color: getValidadeColor(documento) }}>{documento.versaoVigente?.validade ? diasParaVencer(documento.versaoVigente?.validade) : ""}</td>
                            <td onClick={(e) => { menuDocumentoRef.current[index].toggle(e) }} onDoubleClick={(e) => e.stopPropagation()}>
                                <div className="tres-pontos" ></div>
                                <Menu model={renderDocumentoOptions(index)} popup ref={(ref) => menuDocumentoRef.current[index] = ref as Menu} id="popup_menu_left" />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div >
    );
}
